import React from "react";
import { MessageCircle, Phone, Mail, MapPin } from "lucide-react";
import { company, navLinks } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-[#0a1e35] text-white/70">
      {/* CTA strip */}
      <div className="bg-[#0f2846] border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 py-8 flex flex-col md:flex-row items-center justify-between gap-5 text-center md:text-left">
          <p className="text-white/80 text-sm md:text-base">
            <b className="text-white">{company.since}</b> · <b className="text-white">1.000+ motori venduti</b> · Garanzia 12-24 mesi · Spedizione gratuita in tutta Italia
          </p>
          <a href={company.whatsappLink} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-[#22c35e] hover:bg-[#1da851] text-white font-semibold px-6 py-3 rounded-lg transition-all shrink-0">
            <MessageCircle size={18} /> Contattaci su WhatsApp
          </a>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-lg bg-white text-[#0f2846] flex items-center justify-center font-display font-bold text-lg">{company.logoInitials}</div>
            <div>
              <div className="font-display font-bold text-white text-base uppercase">{company.name}</div>
              <div className="text-[10px] tracking-[0.2em] text-white/40 font-semibold">{company.logoSubtitle}</div>
            </div>
          </div>
          <p className="text-sm mt-5 max-w-md leading-relaxed">Vendita di motori usati, rettificati, revisionati e rigenerati per auto di tutte le marche. 16 anni di esperienza, garanzia 12-24 mesi e spedizione gratuita in tutta Italia.</p>
        </div>

        <div>
          <h4 className="font-display font-bold text-white uppercase text-sm tracking-wide">Link utili</h4>
          <ul className="mt-4 space-y-2.5 text-sm">
            {navLinks.map((l) => (
              <li key={l.href}><a href={l.href} className="hover:text-white transition-colors">{l.label}</a></li>
            ))}
            <li><a href="#preventivo" className="hover:text-white transition-colors">Richiedi preventivo</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white uppercase text-sm tracking-wide">Contatti</h4>
          <ul className="mt-4 space-y-3 text-sm">
            {company.phones.map((p, i) => (
              <li key={i}><a href={`tel:+39${p.raw}`} className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={15} /> {p.display}</a></li>
            ))}
            <li><a href={`mailto:${company.email}`} className="flex items-center gap-2 hover:text-white transition-colors break-all"><Mail size={15} /> {company.email}</a></li>
            <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 shrink-0" /> {company.address}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-white/40">
          <span>© {new Date().getFullYear()} {company.name} · P.IVA {company.piva}</span>
          <span>Tutti i diritti riservati</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
